import React from 'react';
import propTypes from 'prop-types';
import { AlertWithMessage } from 'client/components/Be/Alert';
import { Form, Field, reduxForm } from 'redux-form';
import { FormReduxCheckboxCustomRenderer } from 'client/components/Form/FormRedux';
import { StripeBillingSchemeWithAmount } from 'client/components/Helpers/Strings';
import { StripeBillingTiersList } from 'client/components/Helpers/Stripe';
import { getReduxFieldId } from 'client/redux/formHelpers';
import _ from 'lodash';

const isRequired = value => value ? undefined : 'Required';

class AccountSubscriptionChoosePlanForm extends React.Component {

  static propTypes = {
    availablePlans: propTypes.array.isRequired,
    onSelection: propTypes.func.isRequired,
    isFirstSelection: propTypes.bool.isRequired,
  };

  renderFirstSelectionMessage () {
    const { isFirstSelection } = this.props;
    if (!isFirstSelection) return null;
    return (
      <div>
        <AlertWithMessage icon={true} className="alert-icon" alertType="primary">
          <strong>Note:</strong> Choosing a plan paid for every year automatically gives you one extra month for free! (Only applies to certain plans without tiers.)
        </AlertWithMessage>
        <hr />
        <p>
          After adding the first plan to a subscription you can only add plans with the same billing interval and currency unless you create a new subscription!
        </p>
        <hr />
      </div>
    );
  }

  render () {
    const { handleSubmit, onSelection, invalid, availablePlans } = this.props;
    return (
      <Form className="group-border-dashed" onSubmit={handleSubmit(onSelection)}>
        {this.renderFirstSelectionMessage()}
        <Field
          base="accountSubscriptionPlan"
          name="plan"
          component={FormReduxCheckboxCustomRenderer}
          CheckboxListComponent={CheckboxGroup}
          checkboxes={availablePlans}
          validate={[isRequired]}
        />
        <hr />
        <div className="text-center">
          <button type="submit" disabled={invalid} className="btn btn-primary btn-lg btn">Choose</button>
        </div>
      </Form>
    );
  }

}

class CheckboxGroup extends React.Component {

  renderGroup (checkboxes = [], interval) {
    const { input, disabled, type } = this.props;
    return checkboxes.map((plan, index) => {
      const id = getReduxFieldId(this.props, plan.stripeId);
      return (
        <div key={String(interval + '_' + index)} className={`be-${type}`}>
          <input
            {...input}
            id={id}
            disabled={disabled}
            type={type}
            value={plan.stripeId}
            checked={input.value === plan.stripeId}
          />
          <label htmlFor={id}>
            {plan.name}{' '}(<strong><StripeBillingSchemeWithAmount plan={plan} /></strong>)
          </label>
          {plan.billingScheme === 'tiered' && plan.tiers?.length > 0 && (
            <div className="xs-ml-30">
              <StripeBillingTiersList
                tiers={plan.tiers}
                currency={plan.currency}
                unitLabel={plan.unitLabel}
                interval={plan.interval}
              />
            </div>
          )}
        </div>
      );
    });
  }

  render () {
    const { checkboxes } = this.props;

    const plansByCurrency = _.groupBy(checkboxes, plan => plan.currency);
    const groups = _.map(plansByCurrency, (plans, currency) => {
      const plansByInterval = _.groupBy(plans, plan => plan.interval);

      if (!plans.length) {
        return null;
      }

      const children = ['year', 'month'].map((interval) => {
        const checkboxes = plansByInterval[interval];
        if (!checkboxes) return null;
        return (
          <div key={interval}>
            <h4>Plans paid for every {interval}</h4>
            {this.renderGroup(checkboxes, interval)}
          </div>
        );
      });

      return (
        <div key={currency}>
          <h3>Currency: {currency.toUpperCase()}</h3>
          {children}
        </div>
      );
    });

    return (
      <div>
        {groups}
      </div>
    );
  }
}

export default reduxForm({
  form: 'accountSubscriptionChoosePlanForm',
  enableReinitialize: true,
})(AccountSubscriptionChoosePlanForm);
